/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntitySourcelistsOrderBy = {
    EntityId: 'entity_id',
    Asset: 'asset',
    Shared: 'shared',
    Found: 'found',
    Created: 'created',
    Updated: 'updated'
} as const;
export type MonitEntitySourcelistsOrderBy = typeof MonitEntitySourcelistsOrderBy[keyof typeof MonitEntitySourcelistsOrderBy];


export function MonitEntitySourcelistsOrderByFromJSON(json: any): MonitEntitySourcelistsOrderBy {
    return MonitEntitySourcelistsOrderByFromJSONTyped(json, false);
}

export function MonitEntitySourcelistsOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntitySourcelistsOrderBy {
    return json as MonitEntitySourcelistsOrderBy;
}

export function MonitEntitySourcelistsOrderByToJSON(value?: MonitEntitySourcelistsOrderBy | null): any {
    return value as any;
}

